import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ScrollToTop } from './components/ScrollToTop';
import { Home } from './pages/Home';
import { About } from './pages/About';
import { Perspective } from './pages/Perspective';
import { Purpose } from './pages/Purpose';
import { Principles } from './pages/Principles';
import { Practice } from './pages/Practice';
import { Contact } from './pages/Contact';
import { Terms } from './pages/Terms';
import { Privacy } from './pages/Privacy';
import { Subprocessors } from './pages/Subprocessors';
export function AppRouter() {
  return <BrowserRouter data-id="element-0" data-mp="9umyvtetwhgm">
      <ScrollToTop data-id="element-1" data-mp="9v6irfo1hfxa" />
      <Routes data-id="element-2" data-mp="9vptabbd121a">
        <Route path="/" element={<Home data-id="element-4" data-mp="dvgocr7x64bm" />} data-id="element-3" data-mp="9w7xbu49kkjr" />
        <Route path="/about" element={<About data-id="element-6" data-mp="dw8kq49cc62y" />} data-id="element-5" data-mp="duyjj676yhs3" />
        <Route path="/perspective" element={<Perspective data-id="element-8" data-mp="248fn6t1qab8o" />} data-id="element-7" data-mp="dxt3yxq7g2li" />
        <Route path="/purpose" element={<Purpose data-id="element-10" data-mp="248xsef6dbzsq" />} data-id="element-9" data-mp="2497ie2rey6yf" />
        <Route path="/principles" element={<Principles data-id="element-12" data-mp="28a120jxtozli" />} data-id="element-11" data-mp="289rcexgowugc" />
        <Route path="/practice" element={<Practice data-id="element-14" data-mp="287ev8mirao4c" />} data-id="element-13" data-mp="2897vnk2s0c3w" />
        <Route path="/contact" element={<Contact data-id="element-16" data-mp="28z2bh5t3vtgh" />} data-id="element-15" data-mp="28zv9nie01an0" />
        <Route path="/terms" element={<Terms data-id="element-18" data-mp="241acxsxyh93b" />} data-id="element-17" data-mp="28yk4pf8thwub" />
        <Route path="/privacy" element={<Privacy data-id="element-20" data-mp="240r2examxmzb" />} data-id="element-19" data-mp="24225sw064spw" />
        <Route path="/subprocessors" element={<Subprocessors data-id="element-22" data-mp="2iqpvwmr8wa8g" />} data-id="element-21" data-mp="23z7ld4h5n7wh" />
      </Routes>
    </BrowserRouter>;
}